module.exports = __webpack_public_path__ + "static/img/fache.b39adf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/fache.png
// module id = OWVS
// module chunks = 0